// extracted by mini-css-extract-plugin
export default {"container":"TM-z","topReviewHeading":"UM-z","criticalReview":"VM-z","favorableReview":"WM-z","vsSeparator":"XM-z"};